<template>
	<div>
		<div class="empty-img2" v-if="data.length===0">
      <img src="./notes.png"/>
      <p>暂无笔记</p>
    </div>
		<div class="note">
			<ul class="note-items f-cbli" v-dt-infinite-scroll="getData">
				<!--<li class="note-item">
					<div class="note-avatar f-img-box">
						<img src="../index/teacher.png">
					</div>
					<div class="note-content">
						<div class="note-info f-cb">
							<div class="note-name">高圆圆</div>
							<div class="note-time">2小时前</div>
						</div>
						<div class="note-title o1">《如何做出体验良好的动销设计》</div>
						<div class="note-text o2">如何做出体验良好的动销设如何做出体验良好的动销设如何做出体验良好的动销设如何做出体验良好的动销设如何做出体验良好的动销设如何做出体验良好的动销设</div>
						<div class="note-line">
							<div class="note-all">查看全文>></div>
							<div class="note-fav">123</div>
						</div>
					</div>
				</li>-->
				<li class="note-item" v-for="(item,index) in data">
					<div class="note-avatar f-img-box" @click="$router.push('/other/history/'+item.user_id)">
						<img :src="item.avatar?item.avatar:studentAvatar">
					</div>
					<div class="note-content">
						<div class="note-info f-cb">
							<div class="note-name" @click="$router.push('/other/history/'+item.user_id)">{{item.nick_name}}</div>
							<div class="note-time">{{tools.timestampConversion(item.create_time)}}</div>
						</div>
						<div class="note-title o1">{{item.title}}</div>
						<div class="note-text" v-html="item.content"></div>
						<div class="note-mask"></div>
						<div class="note-line">
							<div class="note-all" @click="$router.push('/note/'+item.id)">查看全文>></div>
							<div class="note-fav" :class="{'note-fav-active':item.is_like}" @click="fav(index,item.id)">{{item.like_num}}</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				data:[]
			}
		},
    created() {
      //获取导航参数
      function geturl_j2(name){
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      }
      var v_key = geturl_j2('v_key');
      // if (!/Android|webOS|iPhone|iPod|BlackBerry|HarmonyOS/i.test(navigator.userAgent)) {
      //   window.location.href = "/mooc_free_login/video.html?section_id="+ this.$route.params.id +"&course_id="+ this.$route.params.courseId +"&v_key="+ v_key;
      // }
      // 是不是手机/平板（移动设备）
      const ua = navigator.userAgent || '';
      const isMobile = /Mobile|Android|iPhone|iPod|webOS|BlackBerry|iPad|Tablet/i.test(ua);
      // 如果不是移动设备，才跳PC登录
      if (!isMobile) {
        window.location.href = "/mooc_free_login/video.html?section_id="+ this.$route.params.id +"&course_id="+ this.$route.params.courseId +"&v_key="+ v_key;
      }
    },
    methods:{
			getData(page){
				return new Promise((resolve,reject)=>{
					this.$api.get("",{
            api:"/v1/section_note/noteList",
            course_id:this.$route.params.courseId,
            user_type:this.tools.getStorage("user_type"),
            has_delete:1,
            status: -1,
            len:8,
            page
					},res=>{
						var data=res.data;
						this.data=this.data.concat(data);
						if(data.length<5){
							reject();
						}
						else{
							resolve();
						}
					})
				})
			},
			fav(index,id){
				this.$api.get("",{
					api:"/v1/section_note/addLike",
					id,
					user_type:this.tools.getStorage("user_type")
				},res=>{
					this.data[index].is_like=1;
					this.$toast("点赞成功");
					this.data[index].like_num+=1;
				},res=>{
					this.$toast(res.msg);
				})
			}
		}
	}
</script>

<style>
	.empty{
		padding-top:0.52rem;
		font-size: 0.32rem;
		color:#999;
		text-align: center;
	}
	.note-item{
		padding:0.533rem 0.4rem 0.4rem 0.4rem;
		border-bottom: 1px solid #e6e6e6;
	}
	.note-item:last-child{
		border-bottom: 0;
	}
	.note-avatar{
		float:left;
		overflow: hidden;
		width:1.146rem;
		height:1.146rem;
		border-radius: 50%;
	}
	.note-content{
		float:right;
		width:7.706rem;
	}
	.note-info{
		font-size: 0.346rem;
		line-height: 0.346rem;
	}
	.note-name{
		float:left;
		color:#666;
	}
	.note-time{
		float:right;
		color:#999;
	}
	.note-title{
		margin-top:0.333rem;
		color:#333;
		font-size: 0.453rem;
	}
	.note-text{
		overflow: hidden;
		height:1.6rem;
		margin-top:0.266rem;
		font-size: 0.373rem;
		line-height:0.533rem;
		color:#999;
	}
	.note-text img{
		max-width: 100% !important;
	}
	.note-mask{
		position: relative;
		margin-top:-0.533rem;
		height:0.533rem;
		background:-webkit-linear-gradient(rgba(242,242,242,0),rgba(242,242,242,1));
	}
	.note-line{
		margin-top:0.32rem;
		line-height: 0.346rem;
		font-size: 0.346rem;
		color:#666;
	}
	.note-all{
		float:left;
	}
	.note-fav{
		float:right;
		padding-left:0.44rem;
		background: url(../lesson-evaluate/fav.png) center left no-repeat;
		background-size:0.32rem;
		color:#999;
	}
	.note-fav-active{
		background-image:url(../lesson-evaluate/fav-active.png);
		color:#ff3939;
	}
</style>



// WEBPACK FOOTER //
// src/components/lesson-note/lesson-note.vue